import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-oidc-registration-container",
	templateUrl: "./oidc-registration.container.html",
	styleUrls: ["./oidc-registration.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class OidcRegistrationContainer {
	@HostBinding("class.obg-oidc-registration-container") hostCssClass = true;
}
